import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class UpdateTodo extends Component {
    constructor(){
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            todo: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            message: '',
            redirect: false,
            owners: [],
            title: '',
            description: '',
            visibility: '',
            priority: [],
            status: [],
            start_date: '',
            ETA: '',
            eta: '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            id_error: '',
            error:'',
            startDate:'',
            eta:'',
            todo_attachment:[],
            attachments:'',

        }
        this.updateTodo = this.updateTodo.bind(this);
        this.onChange = this.onChange.bind(this);
        this.startdateChange = this. startdateChange.bind(this);
        this.etadateChange = this.etadateChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleValidation() {
        let fields = this.state.todo;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.todo);
        //Name
        if(!fields["title"]){
           formIsValid = false;
           errors["title"] = "This field is required.";
        }
        if(fields["related_to"] && !this.isValidNumber(fields["related_to"])){
            formIsValid = false;
            errors["related_to"] = "Please Provide Numbers Only.";
        }
       this.setState({errors: errors});
       return formIsValid;
   }
    isValidNumber(number) {
    var pattern = /^[0-9]+$/;
    return pattern.test(number);
    }
    updateTodo(){
        if(this.handleValidation()){
            console.log("Data Has been submitted");
            //return false;
         }else{
            console.log("This Fields Are required.")
            return false;
         }
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if(img>0){
        for (var x = 0; x < img; x++) {
             fd.append("image[]", document.getElementById('attachments').files[x]);
         }
        }
        document.getElementById("add_todo").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl +'/TodoRest/UpdateTodo/userAuthKey/'+ this.state.userAuthKey,{
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/todos/';
                     }); 
                }else  {
                    this.setState({message:findresponse.msg},function(){
                    }); 
                }
              
        }) 
    }

    getTodoDetails() {
        fetch(this.state.apiUrl + '/TodoRest/EditTodo/id/' + this.props.match.params.todoId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.id_error == 1) {
                    window.location.href = '/Unauthorized';
                }
                else(
                this.setState({
                    todo:responseJson.todo,
                    todo_attachment:responseJson.todo_attachment,
                }) )
                if(responseJson.error == 1){
                    window.location.href = '/Unauthorized';
                }
                if(this.state.todo.start_date!='0000-00-00' && this.state.todo.start_date!=''){
                    let x = Date.parse(this.state.todo.start_date);
                    this.setState({startDate:moment(x)})
                }
                if(this.state.todo.ETA!='0000-00-00' && this.state.todo.ETA!=''){
                    let x = Date.parse(this.state.todo.ETA);
                    this.setState({eta:moment(x)})
                }
        })
    }

    addTodoDetails() {
        fetch(this.state.apiUrl + '/TodoRest/Adddetails/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                            window.location.href = '/todos';
                        }); 
                    } else {
                    
                        this.setState({message:findresponse.msg}) 
                    }
                    this.setState({
                        owners: findresponse.owner,
                        priority:findresponse.priority,
                        status:findresponse.status,
                    })
                })
    }
    startdateChange(date){
        this.setState({
            startDate:date,
            start_date:moment(date).format("YYYY-MM-DD")
          },function(){
              console.log(this.state.start_date);
          });
    }
    etadateChange(date){
        this.setState({
            eta:date,
            ETA:moment(date).format("YYYY-MM-DD")
          },function(){
              console.log(this.state.ETA);
          });
    }
    onChange(propertyName,event){
        const todo = this.state.todo;
        todo[propertyName] = event.target.value;
        this.setState({ todo: todo });
    }
    showImage(s3url) {
        window.open(s3url);
    }
    delteimage(id, todo_id) {
        if (window.confirm('Are you sure to delete?')) {
        fetch(this.state.apiUrl + '/TodoRest/deleteTodoImage/id/' + id + '/todo_id/' + todo_id + '/userAuthKey/' + this.state.userAuthKey + '/username/' + this.state.userName)
                .then((Response) => Response.json())
                .then((findresponse) => {
                this.getTodoDetails();
                })
        }
    }
    componentDidMount()
    {
        document.title = "Intranet | Update To Do";
        if(!localStorage.getItem('userLogin')){     
            this.setState({redirect:true});
          }
        this.addTodoDetails();
        this.getTodoDetails();
        $(document).ready(function () {
            $('.upload_btn label').click(function(){
                $('.upload_btn .inputfile').click();
               
            });
            $( '.inputfile' ).each( function()
            {
            var $input	 = $( this ),
                $label	 = $input.next( 'label' ),
                labelVal = $label.html();
        
            $input.on( 'change', function( e )
            {
                var fileName = '';
        
                if( this.files && this.files.length > 1 )
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else if( e.target.value )
                    fileName = e.target.value.split( '\\' ).pop();
        
                if( fileName )
                    $label.find( 'span' ).html( fileName );
                else
                    $label.html( labelVal );
            });
        
            // Firefox bug fix
            $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
        });


            if (window.File && window.FileList && window.FileReader) {
            $("#files").on("change", function(e) {
            var files = e.target.files,
            filesLength = files.length;
            
            });

            } else {
            alert("Your browser doesn't support to File API")
            }
            
            });

    }

    render(){
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          }
        return(
            <div>
                <Header brecum_name="Update To Do" brecum_page="Update To Do"/>
            <div class="right_col">
            <div class="intranet_body">
            <div class="title mob"><HeaderMob page_name="Update To Do"/></div>
            <div className="form-group">
                <label>Title <span class="star">*</span></label>
                <input type="text" name="title"  id="title" className="form-control" onChange={this.onChange.bind(this, 'title')} value={this.state.todo.title}/>
                <span style={{color: "red"}}>{this.state.errors["title"]}</span>
            </div>  
            <div class="form-section add row">
                <div className="form-group col-sm-4 col-xs-6">
                    <label>Owner <span class="star">*</span></label>
                        <select  id="owner" class="form-control" name="owner" onChange={this.onChange.bind(this, 'owner')} value={this.state.todo.owner}>
                            {
                            this.state.owners.map((dynamicData,key)=>
                            <option value={dynamicData.id}>{dynamicData.name}</option>
                                )
                            }
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["owner"]}</span>
                </div>  
                <div className="form-group col-md-4 col-xs-6">
                <label>Priority </label>
                <select class="form-control" name="priority" id="priority"  onChange={this.onChange.bind(this, 'priority')} value={this.state.todo.priority}>
                <option value='' selected ></option>
                        {
                        this.state.priority.map((dynamicData,index)=>
                        <option value={dynamicData.key}>{dynamicData.value}</option>
                            )
                        }	
                </select>
            </div>
            
            <div className="form-group col-sm-4 col-xs-12">
                <label>Visibility  <span class="star">*</span></label>
                <div class="manage_ticket">
                    <label class="custom_radio_ui">
                        <input type="radio" name="visibility" id="visibility1" value="Owner & My manager" onChange={this.onChange.bind(this, 'visibility')} checked={this.state.todo.visibility === 'Owner & My manager'}/>
                        <span></span>Owner & My manager
                    </label>
                    <label class="custom_radio_ui">
                        <input type="radio" name="visibility" id="visibility2" value="public" onChange={this.onChange.bind(this, 'visibility')} checked={this.state.todo.visibility === 'public'}/>
                        <span></span>Public
                    </label>
                </div>
            </div>
            <div className="form-group col-sm-12">
            <label>Description</label>
                <textarea class="checkSpace form-control" name="description" id="description" rows='8' cols='160' onChange={this.onChange.bind(this, 'description')} value={this.state.todo.description}></textarea>
           </div>
            <div className="form-group col-md-3 col-xs-12">
            <label>Status</label>
                <select class="form-control" name="status" id="status"  onChange={this.onChange.bind(this, 'status')} value={this.state.todo.status} >
                <option value='' selected >All</option>
                    {
                        this.state.status.map((dynamicData,index)=>
                        <option value={dynamicData.key}>{dynamicData.value}</option>
                            )
                    }	
                </select>
            </div>
            <div className="form-group col-md-3 col-xs-12">
                <label>Related To</label>
                <input type="text" name="relation"  className="form-control" onChange={this.onChange.bind(this, 'related_to')} value={this.state.todo.related_to}/>
                <span className="error">{this.state.errors["related_to"]}</span> 
            </div>
            <div className="form-group col-md-3 col-xs-6 icon-calender">
                <label>Start Date</label>
                <div class="filter">
                    <DatePicker
                    selected={this.state.startDate}
                    selectsStart
                    onChange={this.startdateChange}
                    readOnly={true}
                    minDate={moment()}
                    maxDate={this.state.eta}
                    placeholderText="Start Date"
                    dateFormat="DD/MM/YYYY"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    />
                    <i class="fal fa-calendar-alt"></i>
                </div>
                <span style={{color: "red"}}>{this.state.etaDate}</span>
            </div>
            <div className="form-group col-md-3 col-xs-6 icon-calender">
            <label>ETA</label>
                <div class="filter right">
                    <DatePicker
                    selected={this.state.eta}
                    selectsEnd
                    onChange={this.etadateChange}
                    readOnly={true}
                    minDate={this.state.startDate == '' ? moment():this.state.startDate}
                    placeholderText="ETA"
                    dateFormat="DD/MM/YYYY"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    />
                <i class="fal fa-calendar-alt"></i>
                </div>
                <span style={{color: "red"}}>{this.state.etaDate}</span>
            </div>
            </div>
            <div class="upload ">
                    <h4 class="pull-left border-bottom"></h4>
                    {
                        this.state.todo_attachment.map((data, key) => 
                    
                        <div class="attached">
                        <span onClick={() => this.showImage(data.url)}  >
                        <i class="far fa-file"></i>{data.attachment_name}
                    </span>
                    <span class="icon_delete" onClick={() => this.delteimage(data.id, data.entity_id)}  >
                        <i class="fa fa-trash"></i>
                    </span>
                    </div>
                    )}
                </div>  
                <div class="upload">
                    <label>Add Attachment :</label>
					<div class="upload_btn">
						<input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple/>
						<label for="file-1">
							<i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
							    <span>Choose file</span>
							<i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
						</label>
					</div>
				</div>
            <div className="update_ticket">
              <button type="submit" name="add_todo" id="add_todo" className="btn btn-sky mob-btn" onClick={()=> this.updateTodo()}>Update Todo</button>
              <Link to={`/viewTodo/${this.state.todo.id}`} name={"max"}><button className="btn btn-blue hidden-sm">Back</button></Link>
            </div>
        </div>
        </div>
        </div>
        )
    }
}

export default UpdateTodo;


// WEBPACK FOOTER //
// ./src/components/todo/updateTodo.js